(() => {
  const notice = document.currentScript?.dataset.newTabNote || '(opens in a new tab)';
  const internalHosts = new Set([location.hostname, 'gentlegiantsacademy.com', 'www.gentlegiantsacademy.com']);
  const seen = new WeakMap();
  const update = link => {
    const href = link.getAttribute('href');
    if (!href || link.closest('#preview-bar-iframe') || link.hasAttribute('download')) return;
    let url;
    try { url = new URL(href, location.href); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol)) return;
    const external = !internalHosts.has(url.hostname);
    const key = href + '|' + link.childElementCount;
    if (seen.get(link) === key) return;
    const utility = link.matches('.skip-to-content-link, .header__heading-link, .header-logo, .gga-account-link') || link.querySelector('img') && !link.textContent.trim();
    if (external) {
      link.target = '_blank';
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      link.setAttribute('rel', [...rel].join(' '));
      const alreadyAnnounced = (link.getAttribute('aria-label') || link.textContent).includes(notice);
      if (!alreadyAnnounced && !link.querySelector('.gga-new-tab-note')) {
        const note = document.createElement('span');
        note.className = 'gga-new-tab-note';
        note.textContent = ' ' + notice;
        link.append(note);
      }
      if (link.hasAttribute('aria-label') && !link.getAttribute('aria-label').includes(notice)) link.setAttribute('aria-label', link.getAttribute('aria-label') + ' ' + notice);
    } else {
      link.querySelectorAll('.gga-new-tab-note').forEach(note => note.remove());
    }
    let arrow = link.querySelector('.gga-line-arrow');
    if (external || (!arrow && !utility)) link.dataset.ggaLinkUpdated = external ? 'External arrow, new tab and screen-reader notice' : 'Internal arrow';
    if (!utility) {
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      let text;
      while ((text = walker.nextNode())) {
        if (!text.parentElement.closest('.gga-new-tab-note, .visually-hidden, svg')) text.textContent = text.textContent.replace(/[→↗]\s*$/, '');
      }
    }
    if (!arrow && !utility) {
      arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      for (const [name, value] of Object.entries({class:'gga-line-arrow',viewBox:'0 0 24 24',width:'16',height:'16',fill:'none',stroke:'currentColor','stroke-width':'1.25','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) arrow.setAttribute(name,value);
      arrow.append(document.createElementNS('http://www.w3.org/2000/svg','path'));
      link.insertBefore(arrow,link.querySelector('.gga-new-tab-note'));
    }
    if (arrow) arrow.querySelector('path').setAttribute('d',external ? 'M5 19 19 5M5 5h14v14' : 'M3 12h18m-7-7 7 7-7 7');
    seen.set(link,href + '|' + link.childElementCount);
  };
  const scan = root => {
    if (root.matches?.('a[href]')) update(root);
    root.querySelectorAll?.('a[href]').forEach(update);
    root.querySelectorAll?.('button[type="submit"] .gga-line-arrow, input[type="submit"] .gga-line-arrow').forEach(arrow=>arrow.remove());
  };
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(node => { if(node.nodeType === 1) scan(node); });
    }
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
})();

